export default [
    // {
    //     caption: '大纲',
    //     id: 'Leading Principles',
    //     items: [
    //         {
    //             name: '2017 全栈开发人员修炼指南',
    //             url: 'http://blog.jobbole.com/112541/',
    //             describe: ''
    //         }, {
    //             name: '6周学习计划，攻克JavaScript难关(React/Redux/ES6 etc.)',
    //             url: 'https://zhuanlan.zhihu.com/p/23412169',
    //             describe: ''
    //         }
    //     ]
    // },
    {
        caption: 'HTML/CSS',
        id: 'HTML/CSS',
        items: [
            // {
            //     name: 'CSS常见布局解决方案',
            //     url: 'http://www.xingxin.me/posts/590058affd9e613545f2d1f3',
            //     describe: ''
            // },
            // {
            //     name: 'CSS布局十八般武艺都在这里了',
            //     url: 'https://zhuanlan.zhihu.com/p/25565751',
            //     describe: ''
            // }, {
            //     name: '未知宽高元素水平垂直居中',
            //     url: 'http://www.cnblogs.com/webcome/p/5497539.html',
            //     describe: ''
            // }, {
            //     name: 'Vertical-Align: All You Need To Know (CSS)',
            //     url: 'https://christopheraue.net/design/vertical-align',
            //     describe: ''
            // }, {
            //     name: '用CSS开启硬件加速来提高网站性能',
            //     url: 'http://www.cnblogs.com/rubylouvre/p/3471490.html',
            //     describe: ''
            // }, {
            //     name: '移动端Web页面适配方案',
            //     url: 'https://segmentfault.com/a/1190000008767416',
            //     describe: ''
            // }, {
            //     name: '网页图片如何适配Retina屏幕',
            //     url: 'http://www.ui.cn/detail/24556.html',
            //     describe: ''
            // }
        ]
    }, {
        caption: 'JavaScript',
        id: 'JavaScript',
        items: [
            {
                name: 'JavaScript 秘密花园',
                url: 'https://bonsaiden.github.io/JavaScript-Garden/zh/',
                describe: ''
            }, {
                name: 'JavaScript 和事件',
                url: 'http://yujiangshui.com/javascript-event/',
                describe: ''
            }, {
                name: 'Javascript 异步编程模型进化',
                url: 'http://foio.github.io/javascript-asyn-pattern/',
                describe: ''
            }, {
                name: 'JavaScript 面向对象简介',
                url: 'https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Introduction_to_Object-Oriented_JavaScript',
                describe: ''
            }, {
                name: 'JavaScript 中的函数式编程实践',
                url: 'https://www.ibm.com/developerworks/cn/web/1006_qiujt_jsfunctional/',
                describe: ''
            }, {
                name: '常用的 Javascript 设计模式',
                url: 'http://blog.jobbole.com/29454/',
                describe: ''
            }, {
                name: 'JavaScript Design Patterns',
                url: 'http://www.dofactory.com/javascript/design-patterns',
                describe: ''
            }
        ]
    }, {
        caption: 'React',
        id: 'React',
        items: [
            // {
            //     name: 'How to Learn React: A Five-Step Plan',
            //     url: 'https://www.lullabot.com/articles/how-to-learn-react?utm_campaign=CodeTengu&utm_medium=web&utm_source=CodeTengu_98',
            //     describe: ''
            // },
            {
                name: 'React.js 小书',
                url: 'http://huziketang.com/books/react/',
                describe: ''
            },
            {
                name: 'Getting Started with Redux',
                url: 'https://egghead.io/courses/getting-started-with-redux',
                describe: ''
            }
        ]
    }, {
        caption: '工具',
        id: 'Tool',
        items: [
            // {
            //     name: 'Getting started with gulp',
            //     url: 'https://markgoodyear.com/2014/01/getting-started-with-gulp/',
            //     describe: ''
            // },
            // {
            //     name: 'Webpack 2 入门教程',
            //     url: 'https://llp0574.github.io/2016/11/29/getting-started-with-webpack2/',
            //     describe: ''
            // },
            // {
            //     name: '为什么我们要做三份 Webpack 配置文件',
            //     url: 'https://zhuanlan.zhihu.com/p/29161762?utm_medium=social&utm_source=qq',
            //     describe: ''
            // }, {
            //     name: '前端测试框架 Jest',
            //     url: 'https://zhuanlan.zhihu.com/p/28162082',
            //     describe: ''
            // }
        ]
    },
    // {
    //     caption: '3. 后端语言',
    //     id: 'Back-End Language',
    //     items: [
    //         {
    //             name: 'Express Tutorial: The Local Library website',
    //             url: 'https://developer.mozilla.org/en-US/docs/Learn/Server-side/Express_Nodejs/Tutorial_local_library_website',
    //             describe: ''
    //         },
    //         {
    //             name: 'User Authentication with Passport and Express 4',
    //             url: 'http://mherman.org/blog/2015/01/31/local-authentication-with-passport-and-express-4/#.WkOvvbeWbIU',
    //             describe: ''
    //         },
    //         {
    //             name: '使用 Express + MongoDB 搭建多人博客',
    //             url: 'https://maninboat.gitbooks.io/n-blog/content/',
    //             describe: ''
    //         }
    //     ]
    // },
    {
        caption: 'HTTP & REST',
        id: 'HTTP & REST',
        items: [
            {
                name: 'Best Practices for your REST API',
                url: 'https://solidgeargroup.com/best-practices-rest-api',
                describe: ''
            }, {
                name: 'Beer Locker: Building a RESTful API With Node',
                url: 'http://scottksmith.com/blog/2014/05/02/building-restful-apis-with-node/',
                describe: ''
            }, {
                name: '前端常见跨域解决方案',
                url: 'https://segmentfault.com/a/1190000011145364',
                describe: ''
            }
        ]
    }, {
        caption: 'Web 应用架构',
        id: 'Web Application Architecture',
        items: [
            {
                name: '前端性能优化最佳实践',
                url: 'https://csspod.com/frontend-performance-best-practices/',
                describe: ''
            }, {
                name: '前端图片优化的方案',
                url: 'http://www.jianshu.com/p/55e48032b30e',
                describe: ''
            }, {
                name: '聊一聊WEB前端安全那些事儿',
                url: 'https://segmentfault.com/a/1190000006672214',
                describe: ''
            }
        ]
    }
]
